import logo from "./logo.svg";
import "./App.css";
import { useDispatch, useSelector } from "react-redux";
import { saveAlertMessage } from "./redux/slice/alertMessage";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import ReactRoutes from "./ReactRoutes";

function App() {
  const dispatch = useDispatch();
  const alertMessage = useSelector((state) => state.alertMessage);

  const togglePopup = () => {
    dispatch(saveAlertMessage(null));
  };

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // For Loader
  const isSomeQueryPending = useSelector((state) =>
    Object.values(state.api.queries).some((query) => query.status === "pending")
  );

  // For Custom Loader
  const customLoader = useSelector((state) => state.loaderNoti);

  useEffect(() => {
    if (customLoader == false) {
      setLoading(false);
    } else if (customLoader == true) {
      setLoading(true);
    }
  }, [customLoader]);

  useEffect(() => {
    if (isSomeQueryPending) {
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
      }, 1500);
    }
  }, [isSomeQueryPending]);

  return (
    <div>
      {/* {alertMessage && (
        <AlertPopUp alertMessage={alertMessage} togglePopup={togglePopup} />
      )} */}
      {loading && (
        <div
          style={{ zIndex: 1500, position: "fixed", top: "45%", left: "49%" }}
        >
          <Spinner
            animation="border"
            className="primary"
            style={{ color: "#624aa4" }}
          />
        </div>
      )}
      <ReactRoutes />
    </div>
  );
}

export default App;
